<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="textes"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table" [formGroupName]="i">
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openTextDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.installationfreetext.label' | translate }}</span>
              </h2>
            </td>
            <td></td>
            <td class="margin" style="width: 50%">
              <div class="ir-form-group">
                <input name="Label" class="ir-form-set" formControlName="Label" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span class="th-plugin-values" style="white-space: nowrap">{{
                  'plugins.installationfreetext.free-text' | translate
                }}</span>
              </h2>
            </td>
            <td colspan="2" class="margin" style="width: 75%">
              <div class="ir-form-group">
                <angular-editor
                  style="width: 100%"
                  name="HtmlContent"
                  class="ir-form-set ir-form-set_freetext angular-editor"
                  formControlName="HtmlContent"
                  [config]="config"
                ></angular-editor>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #textDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
